"use client";
import React from "react";
import { motion } from "framer-motion";
import HeaderInner from "../../utility/HeaderInner";

const AboutUs = () => {
  return (
    <div className="mt-70">
      <HeaderInner
        title={"About US"}
        shortDescription={
          "Leading the EdTech revolution with 25+ years of excellence"
        }
      />

      <div className="py-5 bg-light container">
        {/* Header */}
        <motion.div
          className="text-start mb-5"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="h1 fw-bold text-primary mb-2">About Us</h2>
          <p className="text-secondary fs-5">
            Leading the EdTech revolution with 25+ years of excellence
          </p>
        </motion.div>

        {/* About Section */}
        <motion.div
          className="bg-white rounded-4 shadow p-4 mb-5 transition"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1 }}
        >
          <p className="text-secondary mb-3">
            Coempt Edu Teck is a leading EdTech company with over{" "}
            <span className="fw-semibold text-primary">
              25 years of progressive experience
            </span>{" "}
            in providing end-to-end examination solutions to certificate
            awarding bodies. Our solutions like{" "}
            <span className="fw-semibold">
              OneX, Onmark, EzyTest, and DigiTab
            </span>{" "}
            are envisioned and meticulously developed to empower awarding bodies
            practice transparency and good governance in the assessment and
            examination space.
          </p>

          <p className="text-secondary mb-3">
            We are the most preferred partner to automate critical examination
            processes like pre-examination, question paper management,{" "}
            <span className="fw-semibold text-primary">
              AI-based online examination
            </span>
            , answer-book digitization (uncut), digital evaluation, and post
            examination. Our strong techno-commercial team continuously adapts
            and evolves to implement solutions that impact{" "}
            <span className="fw-semibold">
              over 2 million students each year
            </span>
            .
          </p>

          <p className="text-secondary mb-0">
            We have delivered large turnkey projects empowering clients to
            practice transparency and good governance. With our robust
            solutions, we have impacted millions of students annually and
            partnered with multiple clients in their assessment journey.
          </p>
        </motion.div>

        {/* OneX + Teck Section */}
        <motion.div
          className="bg-primary bg-opacity-10 border-start border-4 border-primary rounded-4 shadow-sm p-4 mb-5 transition"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h3 className="text-primary fw-semibold mb-3">
            Our Flagship Solution
          </h3>
          <p className="text-secondary mb-3">
            <span className="fw-semibold">OneX</span> is our flagship solution
            to automate the entire exam lifecycle — pre-examination, question
            paper management, AI-based online examination, answer-book
            digitization (uncut), digital evaluation, and post-examination.
          </p>

          <p className="text-secondary mb-3">
            We diligently integrate{" "}
            <span className="fw-semibold text-primary">
              Artificial Intelligence (AI) and Blockchain
            </span>{" "}
            to ensure data security, enable automated question paper generation,
            surveillance, and support various exam processes.
          </p>

          <p className="text-secondary mb-0">
            Our approach is to continuously partner and collaborate with
            technology providers, integrating best-in-class devices and
            innovations to deliver a{" "}
            <span className="fw-semibold">one-stop solution</span> for our
            clients.
          </p>
        </motion.div>

        {/* R&D + Certifications */}
        <motion.div
          className="bg-success bg-opacity-10 border-start border-4 border-success rounded-4 shadow-sm p-4 transition"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <h3 className="text-success fw-semibold mb-3">
            Innovation & Quality
          </h3>
          <p className="text-secondary mb-3">
            Our R&D team works tirelessly to innovate and integrate solutions
            based on changing technology trends, ensuring our platforms are{" "}
            <span className="fw-semibold">
              robust, secure, and future-ready
            </span>
            .
          </p>
          <p className="text-secondary mb-0">
            We are <span className="fw-semibold">ISO and CMMi Certified</span>,
            committed to following best quality practices in development and
            delivery. We aim to bridge the digital divide in assessment and
            examination with solutions that uphold{" "}
            <span className="fw-semibold text-primary">
              transparency, governance, and trust
            </span>
            .
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;
